import React from "react";
import { InfrastructureLayer } from "./layers/InfrastructureLayer";
import { TrainLayer } from "./layers/TrainLayer";
import { LabelLayer } from "./layers/LabelLayer";
import { Location } from "@opstel/query/models/location";
import { Action } from "@opstel/query/v2/models/action";
import { ShuntingUnit } from "@opstel/query/models/shuntingUnit";

export interface EPDLayersProps {
  readonly location: Location;
  readonly actions: Action[];
  readonly shuntingUnits: Record<string, ShuntingUnit>;
  readonly showLabels: boolean;
}

export function EPDLayers({
  location,
  actions,
  shuntingUnits,
  showLabels,
}: EPDLayersProps): React.JSX.Element {
  return (
    <>
      <InfrastructureLayer location={location} />
      <TrainLayer
        stablingInfra={location.stablingInfraLookup}
        actions={actions}
        shuntingUnits={shuntingUnits}
      />
      {showLabels && <LabelLayer location={location} />}
    </>
  );
}
